import './index.scss';

const MODAL_SELECTOR = '#js-questions-limit-modal';
const CTA_SELECTOR = '#cta-questions-limit-modal';
const DISMISS_SELECTOR = `${MODAL_SELECTOR} .js-modal-dismiss`;

// This modal is shared by the other flexible limits (comments, commented
// feedback, lessons), which are not part of the copy experiment. `feedbacks.js`
// flags the opening that belongs to it, so the handlers below stay inert
// everywhere else — otherwise their events would pollute the experiment funnel
// and their CTA behaviour would change for no reason.
function isDailyLimitPopup() {
  return $(MODAL_SELECTOR).attr('data-track-daily-limit') === 'true';
}

function emitDailyLimitPopupEvent(eventName) {
  const variant = $(MODAL_SELECTOR).attr('data-variant') || 'control';

  if (typeof UserTracker === 'undefined' || !UserTracker.emit) {
    return;
  }

  UserTracker.emit('event', {
    eventName,
    data: { variant }
  });
}

$(document).ready(function () {
  $(CTA_SELECTOR)
    .off('click.questionsLimitModal')
    .on('click.questionsLimitModal', function (e) {
      if (!isDailyLimitPopup()) {
        return;
      }

      e.preventDefault();

      emitDailyLimitPopupEvent('daily limit popup cta clicked');

      $(MODAL_SELECTOR).modal('hide');

      const href = $(this).attr('href');

      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer');
      }
    });

  $(DISMISS_SELECTOR)
    .off('click.questionsLimitModalDismiss')
    .on('click.questionsLimitModalDismiss', function () {
      if (!isDailyLimitPopup()) {
        return;
      }

      emitDailyLimitPopupEvent('daily limit popup dismissed');
    });
});
